import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 014
        'numConvocatoria' : 'Convocatoria No. 014/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N26-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de avenida Tecnológico de Monterrey, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }14/N26/N26.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 013
        'numConvocatoria' : 'Convocatoria No. 013/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N25-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Análisis, estudio y proyecto para obras de protección del Río Rosas, en el municipio de Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }13/N25/N25.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N24-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Elaboración de estudio de socavación en Río Tula en tramo de colector revestido entre los km 3+400 - 3+800, en el municipio de Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }13/N24/N24.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N23-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de Inmueble para Construcción del Centro Social y Cultural en el municipio de Progreso de Obregón.; ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }13/N23/N23.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
]